<div class="modal-small">
    <h4 class="mb-8">Сonfirmation of deleting</h4>
    <p class="body-2">The tag "{{data.tagName}}" is currently used in {{data.usedInCount}} projects. Deleting it will remove the tag from all associated projects. This action cannot be undone.</p>
    <p class="body-2">Are you sure you want to delete the tag?</p>

    <div class="mt-24">
        <button class="btn btn-primary mr-16" (click)="onDelete()">Delete</button>
        <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
    </div>
    <a mat-dialog-close class="btn-close material-icons-outlined">close</a>
</div>
